import { useGetSimilarPackagesQuery } from '@src/services/packages/packageApiSlice';
import { PackageCard } from './PackageCard';
import { PageSection } from '@src/components';
import { Package } from '@src/services/packages/packageApiSliceTypes';
import { ListItemSkeleton } from '@src/components/Loading/ListItemSkeleton';

interface SimilarPlansProps {
  packageId: string;
  onSelectItem?: (item: Package) => void;
}
export function SimilarPlans({
  packageId,
  onSelectItem,
}: Readonly<SimilarPlansProps>) {
  const { data, isLoading } = useGetSimilarPackagesQuery({ id: packageId });

  if (isLoading) {
    return <ListItemSkeleton />;
  }
  if (data?.length == 0) return <></>;

  return (
    <PageSection>
      <div className='font-bold text-wl-on-background mb-4'>Similar Plans</div>
      <div className='grid grid-cols-1 gap-2'>
        {data
          ?.slice()
          .sort((a, b) => a.price - b.price)
          .map((item) => (
            <button
              key={item.id}
              className='no-underline hover:bg-transparent hover:shadow-none cursor-pointer'
              onClick={() => onSelectItem?.(item)}
            >
              <PackageCard item={item} className='bg-wl-background' />
            </button>
          ))}
      </div>
    </PageSection>
  );
}
